import type { RefObject } from 'react';
import type { AnyFunction } from '../types/common';

import { useEffect, useRef } from 'react';

export function useClickOutside(ref: RefObject<any>, clickOutHandler: AnyFunction) {
  const downRef = useRef<EventTarget | null>(null);

  useEffect(() => {
    if (!ref.current) {
      throw new Error('Unable to setup `useClickOutside` hook, ref is undefined');
    }

    const onDown = (evt: PointerEvent) => {
      downRef.current = evt.target;
    };

    const onUp = (e: PointerEvent) => {
      if (ref.current.contains(downRef.current)) return;

      const inside = ref.current.contains(e.target);

      if (!inside) {
        clickOutHandler();
      }
    };

    window.addEventListener('pointerdown', onDown);
    window.addEventListener('pointerup', onUp);

    return () => {
      window.removeEventListener('pointerdown', onDown);
      window.removeEventListener('pointerup', onUp);
    };
  }, [ref]);
}
